import { ColumnDef } from '@tanstack/react-table'
import { GetMemberLoginHistoryTableData } from '@/modules/manage-member/type'

export const columns: ColumnDef<GetMemberLoginHistoryTableData>[] = [
	{
		accessorKey: 'operator.username',
		header: 'ชื่อผู้ดูแลระบบ',
	},
	{
		accessorKey: 'browser',
		header: 'Browser',
	},
	{
		accessorKey: 'device',
		header: 'Device',
	},
	{
		accessorKey: 'ipAddress',
		header: 'IP Address',
	},
	{
		accessorKey: 'createdAt',
		header: 'เวลา',
		cell: ({ row }) => {
			const date = new Date(row.original.createdAt)
			return date.toLocaleString('th-TH', { timeZone: 'Asia/Bangkok' })
		},
	},
]
